export const TOP_MODEL = 'top_model'
export const MODEL_RANK_CHANGE = 'model_rank_change'
export const MODEL_AVAILABILITY = 'model_availability'
export const MODEL_STABILITY = 'model_stability'
export const NEW_MODEL = 'new_model'
export const NEW_EVALUATION = 'new_evaluation'
export const MODEL_CHANGE = 'model_change'
export const EVAL_SCORE_THRESHOLD = 'eval_score_threshold'

export const EMAIL = 'email'
export const WEBHOOK = 'webhook'
export const TEXT_MESSAGE = 'sms'
export const PHONE_CALL = 'call'

export const FREE_RESPONSE_QUESTION = 'FRQ'
export const MULTIPLE_CHOICE_QUESTION = 'MCQ'
export const BOOLEAN_QUESTION = 'bool'
export const JSON_QUESTION = 'json'

export const REDACTED_COLUMN = 'redacted'
export const TYPE_COLUMN = 'type'
export const QUESTION_COLUMN = 'question'
export const BOOL_CORRECT_COLUMN = 'bool_correct'
export const MCQ_CORRECT_COLUMN = 'mcq_correct'
export const MCQ_INCORRECT_COLUMN = 'mcq_incorrect'
export const FRQ_CORRECT_COLUMN = 'frq_correct'
export const FRQ_INCORRECT_COLUMN = 'frq_incorrect'
export const PARAPHRASE = 'paraphrase'
export const JSON_SCHEMA = 'json_schema'
export const JSON_EXPECTED = 'json_expected'

export const MAX = 'max'
export const MIN = 'min'
export const AVERAGE = 'average'
export const MEDIAN = 'median'
export const SCORE = 'score'
export const ELO_SCORE = 'elo_score'
export const MOST_EXPENSIVE = 'most_expensive'
export const LEAST_EXPENSIVE = 'least_expensive'
export const LATENCY = 'latency'
export const ACCURACY = 'accuracy'
export const AVAILABLE = 'available'
export const ON_UNAVAILABLE = 'on_unavailable'
export const UNAVAILABLE = 'every_unavailable'
export const CHANGE = 'change'

export const GET = 'GET'
export const POST = 'POST'
export const DELETE = 'DELETE'
export const PATCH = 'PATCH'
export const PUT = 'PUT'
export const OPTIONS = 'OPTIONS'
export const HTTP_METHODS = [GET, POST, PATCH, PUT, OPTIONS, DELETE]

export const SESSION_TOKEN = 'session_token'
export const API_TOKEN = 'api_token'
export const COOKIE = 'cookie'
